module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815070_toc01#toctitle8",
      "id": "title8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-chapter"
  }, [_vm._v("SUNDAY AFTERNOON, OCTOBER 30")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("F")]), _vm._v("enimore lay on the sofa, pressing an ice pack to the side of his head. The TV was on, but he wasn’t watching it. He never watched it, unless he was too sick to read or in too much pain to sleep and needed an excuse to do absolutely nothing without appearing to be brooding.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Sal lay curled at his side, her head turned pointedly away from the screen. She shared his opinion of TV. Every now and then an image on the screen would catch Fenimore’s attention—an obnoxious news anchor, an idiotic commercial, or a pretty girl, oops, attractive female person. The first might extract an oath; the second, a snort; the third, a grin. That was the extent of his reaction to the media. Today he felt too terrible to react at all.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fenimore lay perfectly still in order not to jar his head while he stroked Sal. Most of the time he kept his mind a perfect blank, but every now and then the events of the previous night intruded. Questions rose up. Who hit him? Why? He would stop stroking Sal to ponder these questions until she registered her annoyance with an abrupt "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“Meow!”")]), _vm._v(" Then he would resume stroking.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Was the person who had assaulted him the same person who had buried the body? Or an accomplice? How did this person know he had discovered the body? He had been so careful not to let on to the boy. Had the person been lurking nearby when he and Horatio had been engaged in their funeral rites—an uncomfortable thought—and bashed Fenimore on the off chance that he had discovered the body?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("“Meow!”")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Stroke, stroke, stroke.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Had the person meant to do more than injure him and been interrupted? Sal reacted to his too-vigorous stroking by leaping off the sofa.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The phone. He reached for it.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Andrew?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Jennifer.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Dan just called to say you needed cheering up. Is something wrong?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Blast him. “Not a thing. Can’t imagine what … he ran into me at the wrong time … right after a department meeting. You know how they always funk me up. What are you doing today?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Oh, Dad has me inventorying some books that came in Friday from an estate on the Main Line.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Can they read out there?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Snob. Actually, these books belonged to a judge, and they’re quite dog-eared.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Not the usual mint condition, chosen because the binding matched the drapes?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“No, seriously, he even has an impressive collection of mysteries. Mostly trial stuff, but there are a couple of early Chandlers.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Hey, could you save me those? I’d like to take a look at them.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I have a better idea. I’ll bring them over.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Uh, I’m sort of in the middle of something. Billing time … end of the month.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I thought Mrs. Doyle took care of all that.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Usually, but she was on vacation this month. Things pile up.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“I see.” She sounded hurt. “I’ll let you go then.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Maybe you could invite me for dinner some night, and your dad could fill me in on the Lenni-Lenape Indians.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Why?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“They’re a subject of interest to me right now.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“We have a shelf of books about them.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Great. I’ll be over soon.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Shall I serve venison and wild rice garnished with—”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Poison ivy?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“That depends.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“On what?”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("“Lots of things.” On this enigmatic note, she hung up.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fenimore examined his motives. Why had he put Jennifer off? Had he really not wanted her to come? Or did he fear being comforted? Did he secretly yearn to be fed bouillon and read to and generally have his hand held? In short, was he getting soft? If that was the case, he was in the wrong business. Instead of an income supplement, his little sideline might quickly turn into a health hazard. Not that brawn was a weapon he often relied on in his investigations. He didn’t have any. His method was to match wits with his adversaries. But even matching wits required a certain amount of independence and self-reliance. That’s why he had put Jennifer off.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e9b202","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466815070_c07.vue
// module id = 87
// module chunks = 0